export default "images/technical1.png";